import {Component, ElementRef, Input, OnDestroy, OnInit, OnChanges, QueryList, ViewChild, ViewChildren, Output, EventEmitter} from '@angular/core';
import { Subscription } from 'rxjs';
import {UserVerificationService} from '../../services/user-verification.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {HttpService} from '../../services/http.service';
import {DevAddrUtils} from "../../services/devAddr-utils.service";
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false,
  selector: 'app-select-ns-group',
  templateUrl: './select-ns-group.component.html',
})
export class SelectNsGroupComponent implements OnInit, OnDestroy {

  public isAdmin: boolean = false;
  public inputIsDisable = true;
  public inputIsHidden = false;
  public selectIsDisable = false;
  public selectIsHidden = true;
  public inputInit;
  public nsGroupId;
  public subnwkId;
  public isAdminSubscription: Subscription;
  public allNsGroups: any[] = [];
  public haveError = false;
  public errorMessage;
  public errorMessageSubnetworkId;
  nsGroupsList: any[];

  private subnwkIdRegExp = new RegExp(/^([\d\w]{8})(\/([0-9]|1[0-9]|2[0-4]))?$/i);

  @Input() inputValue;
  @Input() inputSubnetworkId;
  @Input() virtId;
  @Input() inputNetId;
  @ViewChild('searchCheck') searchCheck: ElementRef;
  @Output() onNsGroupRemoved: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSave: EventEmitter<void> = new EventEmitter<void>();

  constructor(private userVerificationService: UserVerificationService,
                private http: HttpClient, private httpService: HttpService) {

      this.isAdminSubscription = userVerificationService.message.subscribe(res => this.isAdmin = res);

  }

  private hex2bin(hex: string, length: number) {
    return (parseInt(hex, 16)).toString(2).substr(0, length);
  }

  // Live Search functions
  public selectedNsGroup(value: string) {
    this.haveError = false;
    this.nsGroupId = value;
    this.getNsGroup(this.nsGroupId);
    if(this.subnwkId == "") {
      this.errorMessageSubnetworkId = "SubnetworkID is required.";
      this.haveError = true;
    } else if(!this.subnwkIdRegExp.test(this.subnwkId)) {
      this.errorMessageSubnetworkId = "SubnetworkID is invalid. It should be in the format of <32-bit hex>/<prefix len>, eg. 12ABC0/20";
      this.haveError = true;
    }
  }

  getNsGroup(virtId: string) {
    var url = ApiEndpoints.GET_NETWORK_SERVER_GROUP;
    const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var body: any = {
      "virtId": virtId
    };
    this.http.post<any>(url, body, options).subscribe(
      data => {
         this.inputNetId = "";
         this.inputNetId = data.netIds[0].split("/")[0];
         this.inputSubnetworkId = "";
         this.subnwkId = "";
      });
  }

  public removed(value: string) {
    this.nsGroupId = '';
    this.subnwkId = '';
    this.inputNetId = '';
    this.onNsGroupRemoved.emit();
  }

  // Get all NS Groups Call
  getNsGroups() {
    this.httpService.getNetworkServerGroups()
      .subscribe(
        nsGroupsListRaw => {
          this.nsGroupsList = nsGroupsListRaw;
          for (const nsGroup of nsGroupsListRaw) {
            let devAddrRange = DevAddrUtils.getDevAddrRangeFromNetID(nsGroup.netIds[0].split("/")[0]);
            this.allNsGroups.push({id: nsGroup.virtId, text: nsGroup.name + "," + devAddrRange});
          }
        }
      );
  }

  inputOnClick() {
    this.inputInit = this.inputValue;
    this.subnwkId = this.inputSubnetworkId;
    this.inputIsDisable = false;
    this.haveError = false;
    this.inputIsHidden = true;
    this.selectIsDisable = true;
    this.selectIsHidden = false;
    this.nsGroupId = this.inputValue;
    if(this.subnwkId == "") {
      this.errorMessageSubnetworkId = "SubnetworkID  is required.";
      this.haveError = true;
    } else if(!this.subnwkIdRegExp.test(this.subnwkId)) {
      this.errorMessageSubnetworkId = "SubnetworkID is invalid. It should be in the format of <32-bit hex>/<prefix len>";
      this.haveError = true;
    }
  }

  inputOnSave() {
    let tempValue = this.nsGroupId.toString();
    this.subnwkId = this.addSuffix(this.subnwkId);
    let subNwkIdFromDevAddrRange: string;
    try {
      subNwkIdFromDevAddrRange = DevAddrUtils.getSubnetRangeFromDevAddrRange(this.subnwkId, this.inputNetId);
    } catch (e) {
      this.errorMessage = "DevAddr range is outside the address space of the NS Group's NetID.";
      this.haveError = true;
      return;
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var url = '';
    var body: any = {};
    url = ApiEndpoints.UPDATE_NS_GROUP;
    body = {
      "virtId": this.virtId,
      "subnwkId": subNwkIdFromDevAddrRange,
      "nsGroupVirtId": tempValue,
      "protocolVersion": "1.1"
    };
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.inputValue = tempValue
          this.inputIsDisable = true;
          this.inputIsHidden = false;
          this.selectIsDisable = false;
          this.haveError = false;
          this.selectIsHidden = true;
          this.nsGroupId = "";
          this.subnwkId = "";
          this.errorMessage = "";
          this.onSave.emit();
        },
        error => {
          try {
            let err = JSON.parse(error._body);
            this.errorMessage = JSON.stringify(err.Description);
          } catch(ex) {
            this.errorMessage = "An error has occured!"
          } finally {
            this.haveError = true;
          }
        }
      );
  }

  inputOnCancel(inputCheck) {
    inputCheck.value = this.getNsGroupNameById(this.inputInit) + " - " + this.inputSubnetworkId;
    this.inputIsDisable = true;
    this.inputIsHidden = false;
    this.selectIsDisable = false;
    this.selectIsHidden = true;
    this.haveError = false;
  }

  testValidation(inputCheck, inputElement, event: any) {
    this.haveError = false;
    this.subnwkId = inputCheck;
    if(this.subnwkId == "") {
      this.errorMessageSubnetworkId = "SubnetworkID  is required.";
      this.haveError = true;
    } else if(!this.subnwkIdRegExp.test(this.subnwkId)) {
      this.errorMessageSubnetworkId = "SubnetworkID is invalid. It should be in the format of <32-bit hex>/<prefix len>";
      this.haveError = true;
    } else {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      });
      let options =  {headers: headers};
      this.subnwkId = this.addSuffix(this.subnwkId);
      let subNwkIdFromDevAddrRange: string;
      try {
        subNwkIdFromDevAddrRange = DevAddrUtils.getSubnetRangeFromDevAddrRange(this.subnwkId, this.inputNetId);
      } catch (e) {
        this.errorMessageSubnetworkId = "DevAddr range is outside the address space of the NS Group's NetID.";
        this.haveError = true;
        return;
      }
      var url = ApiEndpoints.EXISTS_SUBNWKID;
      var body: any = {
        "nsGroupId": this.nsGroupId,
        "virtId": this.virtId,
        "subnwkId": subNwkIdFromDevAddrRange
      };
      this.http.post<any>(url, body, options).subscribe(
          data => {
            var subnwkIdExists = data.response;
            if (subnwkIdExists == true) {
              this.haveError = true;
              this.errorMessageSubnetworkId = " SubnwkId already exists in the database!";
            } else {
              this.haveError = false;
            }
          }
      );
    }
  }

  trimValue(event) {
    event.target.value = event.target.value.replace(/\s\s+/g, ' ')
  }

  ngOnInit() {
    $(document).ready(function () {
      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });
    });
    this.subnwkId = this.inputSubnetworkId;
  }

  ngOnChanges() {
    this.getNsGroups();
    if(this.inputSubnetworkId.length > 0) {
      this.inputSubnetworkId = DevAddrUtils.getDevAddrRangeFromSubnetRange(this.inputSubnetworkId, this.inputNetId);
    }
  }

  ngOnDestroy() {
    this.isAdminSubscription.unsubscribe();
  }

  getNsGroupNameById(id: number | string): string {
    if (this.nsGroupsList && this.nsGroupsList.length) {
      const nsGroupInfo = this.nsGroupsList.find(pl => pl['virtId'] === id);
      if (nsGroupInfo) {
        return nsGroupInfo['name'];
      }
    }
    return null;
  }

  private addSuffix(id: any): any {
    if (id !== '') {
      if (id.split('/').length === 1) {
        if (id.length === 6) {
          id += '/24';
        }
      }
    }
    return id;
  }

  private removeSuffix(id: any): any {
    if (id !== '') {
      const splitted = id.split('/');
      if (splitted.length !== 1 && splitted[1] === '24') {
        id = splitted[0];
      }
    }
    return id;
  }

}
